/* eslint-disable max-len */
import { FC } from "react";
import { IIcon } from "./IIcon";

const TitleText: FC<IIcon> = ({ color, size }) => {
  const currentColor = color || "#B3B3B3";
  const currentSize = size || 40;

  return (
    <span>
      <svg
        width={currentSize}
        height={currentSize}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-auto h-auto"
      >
        <rect width="40" height="40" rx="6" fill="white" />
        <path
          d="M10 16L30 16"
          stroke={currentColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 20L30 20"
          stroke={currentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 22L30 22"
          stroke={currentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 24L30 24"
          stroke={currentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default TitleText;
